export default __webpack_public_path__ + "static/zh-9e01f5a8eed0c6bd43a50b68cdffe4ee.png";